import Wrapper from '@/components/shared/Wrapper'
import { Button } from '@/components/ui/button'
import React from 'react'
import { useJobRequisitionStore } from '../../store/useJobRequisitionStore'
import { VIEW_CANDIDATE_MODAL_KEYS } from '../../constant/constant'

const FooterRequestionModification = () => {
      const {setActionModal}=useJobRequisitionStore()
    
  return (
    <Wrapper
        className={
          "flex flex-row items-center gap-2 justify-end  py-[2rem] px-[2.813rem] mt-5"
        }
      >
        <Button
          variant="outline"
          className="px-9 h-[2.625rem] border-none !text-blue-300"
          onClick={() => setActionModal(VIEW_CANDIDATE_MODAL_KEYS.APPROVE)}
        >
          Cancel
        </Button>
        <Button
          variant="destructive"
          className="bg-[#FF9500] !px-4  !py-[1.3rem]"
          onClick={() => setActionModal(VIEW_CANDIDATE_MODAL_KEYS.MODIFICATION_SUBMITTED_SUCCESS)}
        >
          submit modification{" "}
        </Button>
      </Wrapper>
  )
}

export default FooterRequestionModification
